import { formatDate } from "@/utils/format";

export const renderCustomFieldValue = (
	value: string | number | boolean,
	dataType: string,
): string => {
	if (value !== false && !value) {
		return "—";
	}
	switch (dataType) {
		case "string":
			return String(value);
		case "boolean":
			return value ? "True" : "False";
		case "datetime":
			return formatDate(new Date((value as number) * 1000));
		default:
			return String(value);
	}
};
